<template>
	<section>
		<div class="container">
			<div class="row justify-content-center">
				<v-card flat class="col-12 mb-5 p-4 border shadow-sm">
					<form class="row" @submit.prevent="searchGroups">
						<div class="col-2">
							<span for="id">{{ $t("assignStudentGroup.id") }}</span>
							<input
								type="number"
								id="id"
								v-model.number="id"
								class="form-control"
								min="0"
								placeholder="1"
							/>
						</div>
						<div class="col-6">
							<span for="group_name">{{
								$t("assignStudentGroup.groupName")
							}}</span>
							<input
								type="search"
								id="group_name"
								v-model="name"
								class="form-control"
								placeholder="Search here.."
							/>
						</div>
						<div class="col-4 d-flex align-items-end justify-content-end">
							<button
								class="btn btn-primary text-white px-4 me-4"
								type="submit"
							>
								{{ $t("assignStudentGroup.search") }}
							</button>
							<button
								class="btn btn-danger text-white px-4"
								type="reset"
								@click="reset"
							>
								{{ $t("assignStudentGroup.reset") }}
							</button>
						</div>
					</form>
				</v-card>
				<v-card flat class="border">
					<!-- Assign button -->
					<div
						class="d-flex justify-content-between align-items-center p-4"
						v-if="studentGroups.length"
					>
						<button
							class="btn border border-success shadow-sm text-success"
							@click.prevent="goBack"
						>
							<i class="fa-solid fa-chevron-left"></i>
						</button>
						<button class="btn btn-success" @click.prevent="assignGroup">
							{{ $t("assignStudentGroup.assign") }}
						</button>
					</div>
					<div
						v-if="!studentGroups.length"
						class="alert alert-warning text-center mt-5"
						role="alert"
					>
						{{ $t("assignStudentGroup.noAvailableData!") }}
					</div>
					<div class="table-responsive p-4" v-else>
						<h3 class="text-center">
							{{ $t("assignStudentGroup.studentGroups") }}
						</h3>
						<table id="upcomingTable" class="display mt-5 dataTable">
							<thead>
								<tr>
									<th></th>
									<th>{{ $t("assignStudentGroup.id") }}</th>
									<th>{{ $t("assignStudentGroup.groupName") }}</th>
									<th>{{ $t("assignStudentGroup.groupDescription") }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="group of studentGroups" :key="group.id">
									<td>
										<input
											type="radio"
											class="form-check-input"
											name="studentGroup"
											:value="group.id"
											@change="chooseGroup(group)"
										/>
									</td>
									<td>
										{{ group.id }}
									</td>
									<td>
										{{ group.name }}
									</td>
									<td>
										{{ group.description }}
									</td>
								</tr>
							</tbody>
						</table>
						<!-- Pagination -->
						<div class="text-center my-5">
							<v-pagination
								v-model="page"
								:length="getPages"
								:total-visible="4"
								circle
								@input="updateGroups"
							></v-pagination>
						</div>
					</div>
				</v-card>
			</div>
		</div>
	</section>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";

export default {
	name: "AssignStudentGroupView",
	mixins: [GlobalMixin],
	data() {
		return {
			institutes: [],
			currentIns: null,
			studentGroups: [],
			itemsLength: 0,
			currentGroup: {},
			currId: null,
			page: 1,
			offset: 0,
			limit: 10,
			id: null,
			name: null,
		};
	},
	methods: {
		getStudentGroups() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}b2b/group/list/`,
					{
						institute: this.currentIns,
						offset: this.offset,
						limit: this.limit,
					},
					this.headers
				)
				.then(res => {
					const {
						data: { groups, group_count },
					} = res;

					this.studentGroups = groups;
					this.itemsLength = group_count;
				})
				.catch(err => {
					console.error(err);
				});
		},
		chooseGroup(group) {
			this.currentGroup = group;
		},
		reset() {
			this.getStudentGroups();
			this.name = "";
			this.id = "";
		},
		goBack() {
			this.$router.go(-1);
		},
		assignGroup() {
			if (!this.currentGroup.id) {
				Swal.fire({
					position: "center",
					icon: "error",
					title: "Oops...",
					text: "Please choose a group!",
					showConfirmButton: false,
					timer: 1000,
				});
				return;
			}

			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}b2b/class_group/associate/institute_group/`,
					{
						institute: this.currentIns,
						class_group: this.currId,
						student_group: this.currentGroup.id,
					}
				)
				.then(() => {
					Swal.fire({
						position: "center",
						icon: "success",
						text: "Student Group has been assigned successfully!",
						showConfirmButton: false,
						timer: 1000,
					});
					this.$router.push("/dashboard/group-classes");
				})
				.catch(err => {
					const {
						response: {
							data: {
								errors: [{ general }],
							},
						},
					} = err;

					Swal.fire({
						position: "center",
						icon: "error",
						title: "Oops...",
						text: general,
					});
				});
		},
		updateGroups(page) {
			this.offset = (page - 1) * this.limit;
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}b2b/group/list/`,
					{
						institute: this.currentIns,
						offset: this.offset,
						limit: this.limit,
					},
					this.headers
				)
				.then(res => {
					const {
						data: { groups },
					} = res;

					this.studentGroups = groups;
				})
				.catch(err => {
					const {
						response: {
							data: {
								success,
								errors: [{ general }],
							},
						},
					} = err;

					Swal.fire({
						position: "center",
						icon: "error",
						title: "Oops...",
						text: general,
					});
				});
		},
		searchGroups() {
			if (this.name && this.id) {
				this.axios
					.post(
						`${process.env.VUE_APP_APIEndPoint}b2b/group/list/`,
						{
							name: this.name,
							group_id: this.id,
							institute: this.currentIns,
							offset: this.offset,
							limit: this.limit,
						},
						this.headers
					)
					.then(res => {
						const {
							data: { groups },
						} = res;

						this.studentGroups = groups;
					})
					.catch(err => {
						const {
							response: {
								data: {
									success,
									errors: [{ general }],
								},
							},
						} = err;

						Swal.fire({
							position: "center",
							icon: "error",
							title: "Oops...",
							text: general,
						});
					});
			} else if (this.name && !this.id) {
				this.axios
					.post(
						`${process.env.VUE_APP_APIEndPoint}b2b/group/list/`,
						{
							name: this.name,
							institute: this.currentIns,
							offset: this.offset,
							limit: this.limit,
						},
						this.headers
					)
					.then(res => {
						const {
							data: { groups },
						} = res;

						this.studentGroups = groups;
					})
					.catch(err => {
						console.log(err);
					});
			} else {
				this.axios
					.post(
						`${process.env.VUE_APP_APIEndPoint}b2b/group/list/`,
						{
							group_id: this.id,
							institute: this.currentIns,
							offset: this.offset,
							limit: this.limit,
						},
						this.headers
					)
					.then(res => {
						const {
							data: { groups },
						} = res;

						this.studentGroups = groups;
					})
					.catch(err => {
						console.error(err);
					});
			}
		},
	},
	computed: {
		getPages() {
			return Math.ceil(this.itemsLength / this.limit);
		},
	},
	mounted() {
		this.currId = +this.$route.params.id;
		this.currentIns = +this.$route.params.ins;
		this.getStudentGroups();
	},
};
</script>

<style lang="scss" scoped>
table.dataTable {
	border-bottom: none !important;

	thead {
		th {
			text-align: center;
			color: #9f9f9f;
			font-weight: bold;
			border-bottom: 1px solid var(--auth-second-color);
			border-right: 1px solid var(--auth-second-color);
			padding-right: 20px !important;

			&:last-child {
				border-right: none;
			}
		}
	}

	tbody {
		tr {
			background-color: transparent;
			box-shadow: none;

			td {
				text-align: start;
				color: #9f9f9f;
				font-weight: normal;
				background-color: transparent;
				box-shadow: none !important;
				border-bottom: 1px solid var(--auth-second-color);
				border-right: 1px solid var(--auth-second-color);

				&:last-child {
					border-right: none;
				}
			}

			&:last-child {
				td {
					border-bottom: none;
				}
			}

			&:hover {
				background-color: lightgray;

				td {
					color: black;
				}
			}
		}
	}
}
</style>
